import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CardBase } from '../builder-cards.types';
import { ActionType, ActionsSetupArgs } from '../../../builder.types';
import { Select, Store } from '@ngxs/store';
import { FieldDef } from 'app/core/models';
import { FieldDefsState } from 'app/state/fields/state';
import { AutomationState } from 'app/modules/settings/automations/state/state';
import { Observable } from 'rxjs';
import { FileResource } from 'app/shared/modules/folders/folders.types';
import { Automation as AutomationActions } from '../../../../state/actions';

@Component({
  selector: 'app-automation-builder-action-setup-card',
  templateUrl: './action-setup.component.html',
  styleUrls: ['./action-setup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionSetupCardComponent extends CardBase implements OnInit {
  @Input() formData: any;
  @Output() addAction = new EventEmitter();
  @Input() set index(value: number) {
    this._index = value;
    this.action = this.automation.actions[value] ?? null;
  }
  fieldDefs: FieldDef[];
  action: ActionsSetupArgs;
  ActionType = ActionType;

  @Select(AutomationState.getEligibleFiles) eligibleFiles$: Observable<FileResource[]>;

  private _index: number;

  get index(): number {
    return this._index;
  }

  constructor(protected readonly store: Store) {
    super(store);
  }

  ngOnInit(): void {
    this.fieldDefs = this.store.selectSnapshot(FieldDefsState.getFieldDefs);
  }

  getField(fieldName: string): FieldDef {
    return this.fieldDefs.find(
      ({ name, related_to_type }) => name === fieldName && related_to_type === this.automation.target_model,
    );
  }
}
